import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { useLocation, useNavigate } from 'react-router-dom'

import { theme } from '../../themes/theme'
import { FlexColumn, PrimaryColorDivider } from '../styles/Containers'
import { BoldMedBodyText } from '../styles/Text'
import { MenuButton } from '../common/Button'

const SectionContainer = styled(FlexColumn)`
  gap: 8px;
  padding: 10px 15px;
  border: 1px solid ${props => (props.active === 'true' ? theme.colors.primary : 'transparent')};
  border-radius: ${theme.borderRadius.div};
`

const SectionHeader = styled(BoldMedBodyText)`
  color: ${theme.colors.primary};
`

const SettingsMenuButton = styled(MenuButton)`
  font-size: 12px;
`

function SettingsMenuSection({ label, path, subsections = {} }) {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  // Outline only on the section page itself — not when a subsection (e.g. Letters) is active.
  const isSectionPageActive = pathname === path

  return (
    <SectionContainer active={isSectionPageActive.toString()} data-active={isSectionPageActive.toString()} data-testid="settings-menu-section">
      <SectionHeader>{label}</SectionHeader>
      <PrimaryColorDivider />
      {Object.keys(subsections).map(subsection => {
        const { label: subsectionLabel, path: subsectionPath, icon } = subsections[subsection]
        return (
          <SettingsMenuButton key={subsection} active={pathname.startsWith(subsectionPath).toString()} onClick={() => navigate(subsectionPath)}>
            {icon}
            {subsectionLabel}
          </SettingsMenuButton>
        )
      })}
    </SectionContainer>
  )
}

SettingsMenuSection.propTypes = {
  label: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  subsections: PropTypes.object
}

export default SettingsMenuSection
